import React from 'react';
import { DeviceDetailPage } from '../../../../components/DeviceDetailPage';
import { useCurrentAppRoute } from '../../../../hooks/app-route-hooks';
import { AppRoute } from '../../../../routes';
export const OverviewSiteDeviceDetailsTabView: React.FC = () => {
    const currentAppRoute = useCurrentAppRoute();
    const tabId = currentAppRoute.type === 'TimelineSiteTabDetails'
        || currentAppRoute.type === 'TimelineLocationTabDetails'
        || currentAppRoute.type === 'TimelineOrganizationTabDetails' ? currentAppRoute.tabId : '';
    let dynamicBackButton: AppRoute = { type: 'InvalidRoute' }

    if (currentAppRoute.type === 'TimelineSiteTabDetails') {
        dynamicBackButton = {
            type: 'OverviewSiteEventDetails',
            locationId: currentAppRoute.locationId,
            alarmId: currentAppRoute.eventId,
            deviceId: currentAppRoute.deviceId,
            siteId: currentAppRoute.siteId
        }
    }

    if (currentAppRoute.type === 'TimelineSiteTabDetails') {
        dynamicBackButton = {
            type: 'OverviewSiteTimelineEventDetails',
            locationId: currentAppRoute.locationId,
            alarmId: currentAppRoute.eventId,
            deviceId: currentAppRoute.deviceId,
            siteId: currentAppRoute.siteId
        }
    }

    if (currentAppRoute.type === 'TimelineLocationTabDetails') {
        dynamicBackButton = {
            type: 'TimelineLocationEventDetails',
            locationId: currentAppRoute.locationId,
            alarmId: currentAppRoute.eventId,
            deviceId: currentAppRoute.deviceId,
        }
    }
    if (currentAppRoute.type === 'TimelineOrganizationTabDetails') {    
        dynamicBackButton = {
            type: 'TimelineOrganizationEventDetails',
            alarmId: currentAppRoute.eventId,
            deviceId: currentAppRoute.deviceId,
        }
    }
   
    return (
        <DeviceDetailPage
            tabVal={tabId}
            testId="site-details-device-details-pages"
            appRoute={dynamicBackButton}
        />
    );
};